import { rackingTypeAccessorConfig } from 'projectSections/designPanels/PanelModuleGrid/accessors/rackingType'
import { DropdownChangeHandler } from '../../dropdownChangeHandlers'
import { setRelativeTiltForModuleGrids } from '../../utils'
import { enforceNovaTiltMountConstraints } from './NovaHooks'
import { NOVA_LABELS } from './novaLabels'
import { NOVA_TILT_RANGES } from './NovaTiltRanges'

const handleNovaFlushMount: DropdownChangeHandler = (system) => {
  setRelativeTiltForModuleGrids(system, 0)
  system.moduleGrids().forEach((moduleGrid) => {
    rackingTypeAccessorConfig.set({ moduleGrid, value: 'STANDARD' })
  })
}

function handleNovaTiltOption(system: any, tiltOption: string): void {
  const range = NOVA_TILT_RANGES[tiltOption] || NOVA_TILT_RANGES['No tilt']
  system.moduleGrids().forEach((moduleGrid: any) => {
    rackingTypeAccessorConfig.set({ moduleGrid, value: 'TILT_RACK' })
  })
  // setRelativeTiltForModuleGrids uses a rounded slope internally, so the resulting
  // relative tilt can be up to 0.05° below range.min. Add a buffer to ensure
  // the UI validation (which uses the raw slope) never shows a "below minimum" warning.
  setRelativeTiltForModuleGrids(system, range.min + 5)
  enforceNovaTiltMountConstraints(system)
}

const handleNova3Channel: DropdownChangeHandler = (system, translate) => {
  handleNovaFlushMount(system, translate)
  if (system.integration_json?.nova) {
    const updatedJson = {
      ...system.integration_json,
      nova: { ...system.integration_json.nova, tiltOption: 'No tilt' },
    }
    window.editor.execute(new window.SetValueCommand(system, 'integration_json', updatedJson))
  }
}

// Nova requested: Black+2400mm remains selectable (warning-only). resolveColour() falls back
// to Silver SKU intentionally — no auto-revert or hard block required per Nova product team.
const handleNovaRailLength2400: DropdownChangeHandler = (system, translate) => {
  if (system.integration_json?.nova?.componentColour === 'Black') {
    window.Designer?.showNotification(translate(NOVA_LABELS.componentColour2400Tooltip), 'warning')
  }
}

const handleNovaComponentColourBlack: DropdownChangeHandler = (system, translate) => {
  if (Number(system.integration_json?.nova?.railLength) === 2400) {
    window.Designer?.showNotification(translate(NOVA_LABELS.componentColour2400Tooltip), 'warning')
  }
}

export const novaDropdownHandlers: Record<string, Record<string, DropdownChangeHandler>> = {
  tiltOption: {
    'No tilt': handleNovaFlushMount,
    '10-15 deg': (system) => handleNovaTiltOption(system, '10-15 deg'),
    '15-30 deg': (system) => handleNovaTiltOption(system, '15-30 deg'),
    '30-60 deg': (system) => handleNovaTiltOption(system, '30-60 deg'),
    'A-frame (15-30 deg)': (system) => handleNovaTiltOption(system, 'A-frame (15-30 deg)'),
  },
  channels: {
    '3': handleNova3Channel,
  },
  railLength: {
    '2400': handleNovaRailLength2400,
  },
  componentColour: {
    Black: handleNovaComponentColourBlack,
  },
}
